export enum SourceType {
    Engagement = 0,
}

export enum VDRAccessLevel {
    NoAccess = 0,
    FolderOnly = 1,
    FolderAndSubfolders = 2,
}

export const VDRAccessLevelList = [
    { id: 0, name: 'No Access' },
    { id: 1, name: 'This Folder Only' },
    { id: 2, name: 'This Folder & All Sub-Folders' },
];

export interface VDRAccessPermission {
    id: number;
    userId?: number;
    email: string;
    sourceId: number;
    sourceType: SourceType;
    routeUserAccess: string;
    accessLevel: VDRAccessLevel;
    grantedByUserId: number;
    ownerUserId: number;
    dateCreated?: Date;
    dateModified?: Date;
}
